export default "__VITE_ASSET__fd43d820__"